import { Box, Link, Icon, IconButton, Divider, Card } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import LinkIcon from '@mui/icons-material/Link';
import { atom, useAtom, useAtomValue, useSetAtom } from 'jotai';

// common
import { dic } from "@common/text_defs";
// component
import { handleOpenDlgContactUs, } from "@pages/contact/ContactUsDialog";

const WorksSection = () => {
  const openContactUsDlg = useSetAtom(handleOpenDlgContactUs);

  const paneList = [
    {
      imageUrl: "./assets/images/data-extract.png",
      name: dic.works.data_hub_x.title,
      description: dic.works.data_hub_x.desc,
      link: "/prod_data_hub_x",
    },
    {
      imageUrl: "./assets/images/strgy-master-pro.jpg",
      name: dic.works.strgy_master_pro.title,
      description: dic.works.strgy_master_pro.desc,
      link: "/prod_strgy_master_pro",
    },
    {
      imageUrl: "./assets/images/flex-flow.jpg",
      name: dic.works.flex_flow.title,
      description: dic.works.flex_flow.desc,
      link: "/prod_flex_flow",
    },
    {
      imageUrl: "./assets/images/flex-trading2.jpg",
      name: dic.works.flex_trading_2.title,
      description: dic.works.flex_trading_2.desc,
      link: "/prod_flex_trading2",
    },
    {
      imageUrl: "./assets/images/works-crm.jpg",
      name: dic.works.customer_ims.title,
      description: dic.works.customer_ims.desc,
    },
    {
      imageUrl: "./assets/images/power-drs.jpg",
      name: dic.works.power_drm.title,
      description: dic.works.power_drm.desc,
    },
    {
      imageUrl: "./assets/images/power_futures.jpg",
      name: dic.works.power_futures.title,
      description: dic.works.power_futures.desc,
    },
    {
      imageUrl: "./assets/images/prod_DR.png",
      name: dic.works.power_drs.title,
      description: dic.works.power_drs.desc,
    },
  ];
  const handleAction = async (act: string, vd: unknown) => {
  }
  const handleClickLink = async () => {
    openContactUsDlg(handleAction)
  }

  return (
    <Box component="section" className="section bg-light-gray" id="works" sx={{ pb: 0 }}>
      <Box component="div" className="container">
        <div className="section__header">
          <h2>{dic.works.main_title}</h2>
          <p>
            {dic.works.sub_title}
          </p>
        </div>
        <Grid container spacing={3}>
          {paneList.map((pane, index) => (
            <Grid md={3} sm={6} xs={12} key={index}>
              <Card className="relative card" key={index} sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
                <Link href="#" onClick={handleClickLink}>
                  <img
                    className="w-full"
                    src={pane.imageUrl}
                    alt="portfolio"
                  />
                </Link>
                <Box sx={{ px: 4, pt: 4 }}>
                  <h5 className="m-0 text-16 font-bold">{pane.name}</h5>
                  <p className="mb-4">{pane.description}</p>
                </Box>
                <Box sx={{ flexGrow: 1 }}></Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box >
  );
};

export { WorksSection };
